// import { create } from 'zustand';
// import { persist } from 'zustand/middleware';

// export const useFilterStores = create(
//     persist(
//         (set, get) => ({
//             filterState: {
//                 parking: null,
//                 basement: null,
//                 elevator: null,
//                 priceFrom: null,
//                 priceTo: null,
//                 meterageFrom: null,
//                 meterageTo: null,
//                 buldingLifeFrom: null,
//                 buldingLifeTo: null,
//                 depositFrom: null,
//                 depositTo: null,
//                 rentFrom: null,
//                 rentTo: null,
//                 selectedAreas: [],
//                 adsAdvertiseTypeCode: 0,
//                 selectedCategoryItem: 0,
//                 selectedMelkTypeItem: 0,
//                 selectedMelkMoameleItem: 0,
//                 noeAgahiDahande: 0,
//             },
//             actions: {
//                 updateFilterState: (newFilters) => {
//                     set((state) => ({
//                         filterState: { ...state.filterState, ...newFilters },
//                     }));
//                 },


//                 resetFilterState: () => {
//                     set({
//                         filterState: {
//                             parking: null,
//                             basement: null,
//                             elevator: null,
//                             priceFrom: null,
//                             priceTo: null,
//                             meterageFrom: null,
//                             meterageTo: null,
//                             buldingLifeFrom: null,
//                             buldingLifeTo: null,
//                             depositFrom: null,
//                             depositTo: null,
//                             rentFrom: null,
//                             rentTo: null,
//                             selectedAreas: [],
//                             adsAdvertiseTypeCode: 0,
//                             selectedCategoryItem: 0,
//                             selectedMelkTypeItem: 0,
//                             selectedMelkMoameleItem: 0,
//                             noeAgahiDahande: 0,
//                         },
//                     });
//                 },

//             }
//         })
//     )

// )

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// export const useFilterStores = create(
//     persist(
//         (set, get) => ({

//             filterState: {
//                 parking: null,
//                 basement: null,
//                 elevator: null,
//                 priceFrom: null,
//                 priceTo: null,
//                 meterageFrom: null,
//                 meterageTo: null,
//                 buldingLifeFrom: null,
//                 buldingLifeTo: null,
//                 depositFrom: null,
//                 depositTo: null,
//                 rentFrom: null,
//                 rentTo: null,
//                 selectedAreas: [],
//                 adsAdvertiseTypeCode: 0,
//                 selectedCategoryItem: 0,
//                 selectedMelkTypeItem: 0,
//                 selectedMelkMoameleItem: 0,
//                 noeAgahiDahande: 0,
//             },
//             actions: {

//                 updateFilterState: (newFilters) => {
//                     set((state) => ({
//                         filterState: { ...state.filterState, ...newFilters },
//                     }));
//                 },
//                 resetFilterState: () => {
//                     set({
//                         filterState: {
//                             parking: null,
//                             basement: null,
//                             elevator: null,
//                             priceFrom: null,
//                             priceTo: null,
//                             meterageFrom: null,
//                             meterageTo: null,
//                             buldingLifeFrom: null,
//                             buldingLifeTo: null,
//                             depositFrom: null,
//                             depositTo: null,
//                             rentFrom: null,
//                             rentTo: null,
//                             selectedAreas: [],
//                             adsAdvertiseTypeCode: 0,
//                             selectedCategoryItem: 0,
//                             selectedMelkTypeItem: 0,
//                             selectedMelkMoameleItem: 0,
//                             noeAgahiDahande: 0,
//                         },
//                     });
//                 },
//             },
//         }),
//         {
//             name: 'filtered-values', // Key for localStorage
//         }
//     )
// );

export const useFilterStores = create(
    persist(
        (set, get) => ({
            filterState: {
                parking: null,
                basement: null,
                elevator: null,
                priceFrom: null,
                priceTo: null,
                meterageFrom: null,
                meterageTo: null,
                buldingLifeFrom: null,
                buldingLifeTo: null,
                selectedAreasIDs: [],
                selectedTradeType: null,
                selectedPropertyType: null,
                isCommunal: false,
                isPersonal: false,
                isGeneric: false,
                numberOfRoomsFrom: null,
                numberOfRoomsTo: null,
            },
            updateFilterState: (newFilters) => {
                set((state) => ({
                    filterState: { ...state.filterState, ...newFilters },
                }));
            },
            // resetFilterState: () => {
            //     set({
            //         filterState: {
            //             parking: null,
            //             basement: null,
            //             elevator: null,
            //             priceFrom: null,
            //             priceTo: null,
            //             selectedAreasIDs: [],
            //             isCommunal: false,
            //             isPersonal: false,
            //             isGeneric: false,
            //             numberOfRoomsFrom: null,
            //             numberOfRoomsTo: null,
            //         },
            //     });
            // },
            resetFilterState: () => {
                set({
                    filterState: {
                        parking: null,
                        basement: null,
                        elevator: null,
                        priceFrom: null,
                        priceTo: null,
                        meterageFrom: null,
                        meterageTo: null,
                        buldingLifeFrom: null,
                        buldingLifeTo: null,
                        selectedAreasIDs: [],
                        selectedTradeType: null,
                        selectedPropertyType: null,
                        isCommunal: false,
                        isPersonal: false,
                        isGeneric: false,
                        numberOfRoomsFrom: null,
                        numberOfRoomsTo: null,
                    },
                });
            },
            updateSelectedTradeType: (tradeType) => {
                set((state) => ({
                    filterState: { ...state.filterState, selectedTradeType: tradeType },
                }));
            },
            updateSelectedPropertyType: (propertyType) => {
                set((state) => ({
                    filterState: { ...state.filterState, selectedPropertyType: propertyType },
                }));
            },
        }),
        {
            name: 'filter-storage',
        }
    )
);
